import { useState } from 'react';

const ToggleHandler = ({
  options,
  current,
  setCurrentTab,
}: {
  options: string[];
  current: string;
  setCurrentTab: (tab: string) => void;
}) => {
  return (
    <div className={`flex bg-side-nav-button-bg w-full`}>
      {options.map(option => (
        <div
          key={option}
          className={`flex justify-center items-center border cursor-pointer h-12 w-1/2  ${
            current === option
              ? 'border-green-light-color font-semibold rounded-sm bg-white text-button-light-green'
              : 'border-transparent rounded-tl rounded-bl  font-medium bg-side-nav-button-bg text-[#62646B]'
          }`}
          onClick={current !== option ? () => setCurrentTab(option) : undefined}
        >
          <span className="text-base">{option}</span>
        </div>
      ))}
    </div>
  );
};

export default ToggleHandler;
